import { render, staticRenderFns } from "./NotificationMenu.vue?vue&type=template&id=9abd41fe&scoped=true"
import script from "./NotificationMenu.vue?vue&type=script&lang=js"
export * from "./NotificationMenu.vue?vue&type=script&lang=js"
import style0 from "./NotificationMenu.vue?vue&type=style&index=0&id=9abd41fe&prod&lang=scss&scoped=true"
import style1 from "./NotificationMenu.vue?vue&type=style&index=1&id=9abd41fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abd41fe",
  null
  
)

export default component.exports